import React from 'react';

const AHref = ({href, children}) => (
  <a
    className="text-14 leading-tight text-blue underline hover:no-underline cursor-pointer"
    href={href}>
    {children}
  </a>
);

function FooterOnline() {
  return (
    <div className="absolute left-0 right-0 bg-purple-lightest">
      <div className="boxes">
        <div className="container md:px-0 py-6">
          <div className="help">
            <h4 className="mb-2">
              Ai nevoie de ajutor din partea <strong>Credex IFN</strong>? Nu
              ezita sa ne contactezi!
            </h4>
            <div className="flex justify-between flex-wrap font-14">
              <p>
                <span className="mr-1">Telefon:</span>
                <AHref href="tel:+40219912">021 9912 (L-V: 9-18)</AHref>
              </p>
              <p>
                <span className="mr-1">Email:</span>
                <AHref href="mailto:crediteonline@credex-ifn.ro">
                  crediteonline@credex-ifn.ro
                </AHref>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FooterOnline;
